<template>
    <div class="Tjenester" id="back1">
       <div class="form-wrap container">
    <v-tabs v-model="active" color="cyan" dark slider-color="yellow" fixed-tabs>
      <v-tab v-for="item in items" :key="item" ripple>
        {{item.tab }}
        <br>
        {{item.tab2 }}
      </v-tab>
      <v-tab-item v-for="item in items" :key="item">
        <md-list>
          <md-card>
            <md-card-header>
              <md-card-header-text>
                <div class="md-title">{{ item.tabtekst }}</div>
              </md-card-header-text>

              <md-card-media md-big>
                <img :src="item.src">
              </md-card-media>
            </md-card-header>

            <md-card-footer>Kontakt oss om løsning og pris.</md-card-footer>
          </md-card>
        </md-list>
      </v-tab-item>
    </v-tabs>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.md-card {
  width: 95%;

  height: 300px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
  background: rgb(134, 192, 184);
}
.md-list {
  min-width: 450px;
  width: 33%;

  display: inline-block;
  overflow: auto;
  vertical-align: top;
}
</style>

<script>
export default {
  data() {
    return {
      active: null,
      items: [
        {
          tab: "Ny",
          tab2: "bygg",
          tabtekst: "Vi tek tilbygg, garasje, nøst osv.",
          src: require("../assets/Bilder/Tjenester/Nybygg.jpg")
        },
        {
          tab: "Rehabili",
          tab2: "tering",
          tabtekst: "Vi tek rehabilitering, opppussing, gulv osv.",
          src: require("../assets/Bilder/Tjenester/Rehabilitering.jpg")
        },
        {
          tab: "Tak",
          tab2: "skift",
          tabtekst: "Vi tek takskift, forarbeid, råteskader osv.",
          src: require("../assets/Bilder/Tjenester/Takskift.jpg")
        },
        {
          tab: "Bad",
          tab2: "",
          tabtekst: "Vi tek bad, forarbeid, råteskader osv.",
          src: require("../assets/Bilder/Tjenester/Bad.jpg")
        },
        {
          tab: "Kjøkken",
          tab2: "montering",
          tabtekst: "Vi tek kjøkkenmontering, forarbeid, nye vegger osv.",
          src: require("../assets/Bilder/Tjenester/Kjokken.jpg")
        }
      ]
    };
  },
  methods: {
    next() {
      const active = parseInt(this.active);
      this.active = active < 2 ? active + 1 : 0;
    }
  }
};
</script>

<style lang="scss" scoped>

</style>